module.exports = __webpack_public_path__ + "static/media/yelp_thumbnail.171f2977.png";


//////////////////
// WEBPACK FOOTER
// ./src/work/src/yelp_thumbnail.png
// module id = 384
// module chunks = 0